import MenuIcon from '@mui/icons-material/Menu';
import ApiIcon from '@mui/icons-material/Api';
import PlayCircleOutlineIcon from '@mui/icons-material/PlayCircleOutline';
import MicNoneIcon from '@mui/icons-material/MicNone';
import QueueMusicIcon from '@mui/icons-material/QueueMusic';
import DialpadIcon from '@mui/icons-material/Dialpad';
import FolderOpenIcon from '@mui/icons-material/FolderOpen';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { formatHebrewDateTimeSeconds } from '../../utils/hebrewDate';

/** מטא-דאטה ויזואלית לפי type של שלוחת ימות */
export function ivrTypeMeta(type) {
  const t = String(type || '').toLowerCase();
  if (t.includes('api')) {
    return { label: 'API', color: '#0d47a1', Icon: ApiIcon };
  }
  if (t.includes('menu') || t === 'id_list') {
    return { label: 'תפריט', color: '#1565c0', Icon: MenuIcon };
  }
  if (t.includes('play') || t.includes('last_play') || t === 'file') {
    return { label: 'השמעה', color: '#00838f', Icon: PlayCircleOutlineIcon };
  }
  if (t.includes('record') || t.includes('voicemail')) {
    return { label: 'הקלטה', color: '#6a1b9a', Icon: MicNoneIcon };
  }
  if (t.includes('queue') || t.includes('routing') || t.includes('conference')) {
    return { label: 'ניתוב', color: '#ef6c00', Icon: QueueMusicIcon };
  }
  if (t.includes('exam') || t.includes('trivia') || t.includes('points')) {
    return { label: 'מבחן', color: '#2e7d32', Icon: DialpadIcon };
  }
  if (t.includes('turbo')) {
    return { label: 'טורבו', color: '#c62828', Icon: DialpadIcon };
  }
  if (!t) {
    return { label: 'שלוחה', color: '#455a64', Icon: FolderOpenIcon };
  }
  return { label: type, color: '#546e7a', Icon: HelpOutlineIcon };
}

export function formatFetchedAt(iso) {
  return formatHebrewDateTimeSeconds(iso);
}
